export enum EPlatformPayments {
  WEB = 'WEB',
  MOBILE = 'MOBILE',
  POS = 'POS',
}



export default EPlatformPayments;
